import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getJobDisplayNameFormat } from 'lib/selectors/getJobDisplayNameFormat';
import { formatOrderOpName } from 'lib/utils/jobDisplayName';

function useJobDisplayName() {
  const jobDisplayNameFormat = useSelector(getJobDisplayNameFormat);

  const getOrderOpDisplayName = useCallback(
    (op) => {
      if (!op) return '';
      return formatOrderOpName(op, jobDisplayNameFormat) || '';
    },
    [jobDisplayNameFormat]
  );

  return { getOrderOpDisplayName };
}

export { useJobDisplayName };
